import React from "react";

const sleep = (m) => new Promise((r) => setTimeout(r, m));

const RELOAD_GUARD_KEY = "@facilita-app/chunk-reload-attempt";
const RELOAD_WINDOW_MS = 10000;

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  String(error?.message || "").includes("Loading chunk");

export default function asyncComponent(importComponent) {
  class AsyncComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
        failed: false,
      };

      this.isMountedComponent = false;
    }

    componentWillUnmount() {
      this.isMountedComponent = false;
    }

    async componentDidMount() {
      this.isMountedComponent = true;

      try {
        await sleep(process.env.NODE_ENV === "development" ? 150 : 0);
        const { default: component } = await importComponent();

        if (!this.isMountedComponent) return;

        this.setState({ component });
      } catch (error) {
        console.error("async:component:load:error", error);

        if (!this.isMountedComponent) return;

        const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
        const reloadedRecently = Date.now() - lastReloadAt < RELOAD_WINDOW_MS;

        if (isChunkLoadError(error) && !reloadedRecently) {
          sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
          window.location.reload();
          return;
        }

        this.setState({ failed: true });
      }
    }

    render() {
      const { component: C, failed } = this.state;

      if (C) return <C {...this.props} />;

      if (failed) {
        return (
          <div style={{ padding: "16px", textAlign: "center" }}>
            Ocorreu um erro ao carregar a tela. Recarregue a página.
          </div>
        );
      }

      return <div style={{ minHeight: "40px" }} />;
    }
  }

  return AsyncComponent;
}
